import React, { useCallback, useEffect, useState } from "react";
import { Editor, Node, Transforms, createEditor } from "slate";
import { Slate, Editable, withReact, ReactEditor } from "slate-react";

import CodeElement from "./elements/CodeElement";
import SpeakerElement from "./elements/SpeakerElement.tsx";

import "../../App.css";
import { useLoaderData, useParams } from "react-router-dom";
import PersoModal from "./components/modal/PersoModal";
import CustomEditorConfig from "./CustomEditorConfig";
import Layout, { Content, Footer } from "antd/es/layout/layout";
import HeaderEditor from "./components/Layout/HeaderEditor";
import SiderEditor from "./components/Layout/SiderEditor";
import GenericLeaf from "./leaves/GenericLeaf";
import DicoModal from "./components/modal/DicoModal";
import withImages from "./plugins/withImages";
import ImageElement from "./elements/ImageElement";
import { getFile } from "../../api/Get";
import { publishV1, saveFile } from "../../api/Post";
import { toDocx } from "./exporter/toDocx";
import { withHistory } from "slate-history";
import { message } from "antd";

const fileLoader = async ({ params }) => {
  const details = await getFile(params.uidFile);
  return details;
};

/**
 * 
 * {
    type: "paragraph",
    children: [{ text: "A line of text in a paragraph." }],
  },
 */

// const initialValue = {
//   data: [
//     {
//       line: {
//         text: "À peine descendue de la voiture, Faustine râlait déjà.",
//         speaker: "narrateur",
//       },
//     },
//     {
//       line: {
//         text: "Mamaaaaannnn… Le parapluie, st’eupl’ !",
//         speaker: "Faustine",
//       },
//     },
//     {
//       line: {
//         text: "Oh, eh, Faustine, pas la peine de hurler comme ça. Tiens.",
//         speaker: "Maman",
//       },
//     },
//     {
//       line: {
//         text: "Pfff, pas ma faute s’il pleut toujours en Bretagne. Super, les vacances de la Toussaint !",
//         speaker: "Faustine",
//       },
//     },
//   ],
// };
const MainPage = () => {
  const { lines, episode } = useLoaderData();

  const [editor] = useState(() =>
    withHistory(withImages(withReact(createEditor())))
  );
  const [modalPersoIsOpen, setPersoIsOpen] = React.useState(false);
  const [modalDicoIsOpen, setDicoIsOpen] = React.useState(false);
  const [speakerElement, setSpeakerElement] = useState();
  const [showPreviewer, setShowPreviewer] = useState(false);

  const [selectedText, setSelectedText] = useState({});
  const [searchDico, setSearchDico] = useState("");

  const [persos, setPersos] = useState([]);

  const [docContent, setDocContent] = useState({ lines });
  const [epLength, setEpLength] = useState(0);

  const [isSaving, setIsSaving] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const { uidFile } = useParams();

  const renderElement = useCallback(
    (props) => {
      switch (props.element.type) {
        case "code":
          return <CodeElement {...props} />;
        case "speaker":
          return (
            <SpeakerElement
              {...props}
              onClick={() => {
                const path = ReactEditor.findPath(editor, props.element);
                Transforms.select(editor, [...path, 0]);
                setSpeakerElement(props.element);
                setPersoIsOpen(true);
              }}
            />
          );
        case "image":
          return (
            <ImageElement
              onDelete={(path) => {
                console.log("click remove", path);
                CustomEditorConfig.removeImage(editor, path);
              }}
              pathParams={{
                numEp: episode.number,
                numSeason: episode.Season.number,
                uidSerie: episode.Season.Serie.uid,
                uidCollection: episode.Season.Serie.Collection.uid,
              }}
              {...props}
            />
          );

        default:
          return <p {...props.attributes}>{props.children}</p>;
      }
    },
    [editor, episode]
  );

  const renderLeaf = useCallback((props) => {
    return <GenericLeaf {...props} />;
  }, []);

  const storePersoInfos = useCallback(() => {
    const generator = Editor.nodes(editor, {
      at: {
        anchor: Editor.start(editor, []),
        focus: Editor.end(editor, []),
      },
      match: (n) => n.speaker,
    });

    const tmpPersos = [];
    for (const m of generator) {
      const speaker = m[0].speaker;
      if (speaker.name.toLowerCase() !== "narrateur") {
        const doesInclude = tmpPersos.findIndex((p) => p.name === speaker.name);
        if (doesInclude <= -1) tmpPersos.push(speaker);
      }
    }
    setPersos(tmpPersos);
  }, [editor]);

  const setSpeaker = (perso, changeAll) => {
    setPersoIsOpen(false);
    CustomEditorConfig.setSpeaker(editor, perso, speakerElement, changeAll);
    storePersoInfos();
  };

  const openPersoModal = () => {
    if (editor.savedSelection) {
      Transforms.select(editor, editor.savedSelection);
      setSpeakerElement(Editor.fragment(editor, editor.savedSelection)[0]);
      setPersoIsOpen(true);
    }
  };

  const openDicoModal = (selection) => {
    setDicoIsOpen(true);
    setSearchDico(selection);
  };

  const addPersoToElement = (perso) => {
    if (editor.savedSelection) {
      Transforms.select(editor, editor.savedSelection);
      setSpeakerElement(Editor.fragment(editor, editor.savedSelection)[0]);
      setSpeaker(perso);
    }
  };

  const saveSelection = () => {
    editor.savedSelection = editor.selection;
  };

  const markAsBold = () => {
    CustomEditorConfig.toggleBoldMark(editor);
  };

  const markAsItalic = () => {
    console.log("Mark as italic");
    CustomEditorConfig.toggleItalicMark(editor);
  };

  const markAsShouldDelete = () => {
    console.log("Mark as should delete");
    CustomEditorConfig.toggleShouldDeleteMark(editor);
  };

  const markAsDico = (dico) => {
    console.log(selectedText);

    if (selectedText.selection !== dico.word)
      return messageApi.open({
        type: "error",
        content:
          "La casse, les accents et les caractères spéciaux doivent être identiques pour ajouter le dico",
      });

    CustomEditorConfig.toggleDicoMark(editor, dico);
  };

  const onDrop = React.useCallback(
    (event) => {
      if (event.target) return;
      const node = ReactEditor.toSlateNode(editor, event.target);
      const path = ReactEditor.findPath(editor, node);
      const voidMatch =
        Editor.isVoid(editor, node) ||
        Editor.void(editor, {
          at: path,
          voids: true,
        });
      const disableSlateOnDrop = voidMatch ? true : null;
      return disableSlateOnDrop;
    },
    [editor]
  );

  const addImage = () => {
    if (editor.savedSelection) {
      Transforms.select(editor, editor.savedSelection);
      CustomEditorConfig.insertImage(
        editor,
        ""
        // "https://img.freepik.com/photos-gratuite/jetee-au-bord-lac-hallstatt-autriche_181624-44201.jpg"
      );
    }
  };

  const saveDoc = useCallback(async () => {
    await saveFile(uidFile, docContent);
    setIsSaving(false);
  }, [uidFile, docContent]);

  const publish = async () => {
    saveDoc();
    const fileSaved = await publishV1(uidFile, docContent);
    if (fileSaved.success === "ok")
      messageApi.open({
        type: "success",
        content: "Épisode intégré",
      });
    else
      messageApi.open({
        type: "error",
        content: "Épisode pas intégré",
      });
    console.log(fileSaved);
  };

  useEffect(() => {
    storePersoInfos();
  }, [editor, storePersoInfos]);

  useEffect(() => {
    const extractText = (child) => {
      console.log(child);
      if (child.children.length > 1)
        return child.children.reduce((acc, c) => (acc += c.text.length), 0);
      return child.children[0].text.length;
    };
    setEpLength(
      docContent.lines.reduce((acc, l) => (acc += extractText(l)), 0)
    );

    setIsSaving(true);
    const delayDebounceFn = setTimeout(async () => {
      if (docContent.lines.length > 0) await saveDoc();
    }, 3000);

    return () => clearTimeout(delayDebounceFn);
  }, [docContent, saveDoc]);

  const onPrint = async () => {
    setShowPreviewer(true);

    const printContents = document.getElementById("printablediv").innerHTML;
    const previewer = document.getElementById("previewer");

    // Reset preview
    previewer.innerHTML = "";

    const paged = await import("./exporter/toPDF");
    await paged.preview(
      printContents,
      ["./helper/Printer.css", "../../App.css"],
      document.getElementById("previewer")
    );
    window.print();
    setShowPreviewer(false);
  };

  const onDocx = async () => {
    toDocx(docContent, `EP${episode.number} - ${episode.name}.docx`);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {contextHolder}
      <div
        id={"previewer"}
        style={{
          backgroundColor: "white",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          display: showPreviewer ? "block" : "none",
        }}
      />
      <SiderEditor
        addPerso={addPersoToElement}
        addImage={addImage}
        markAsBold={markAsBold}
        markAsItalic={markAsItalic}
        markAsDico={markAsDico}
        markAsShouldDelete={markAsShouldDelete}
        openPersoModal={openPersoModal}
        openDicoModal={openDicoModal}
        persos={persos}
        selectedText={selectedText}
        epLength={epLength}
      />
      <Layout>
        <HeaderEditor
          onPrint={onPrint}
          onDocx={onDocx}
          onPublish={publish}
          onSave={() => {
            setIsSaving(true);
            saveDoc();
          }}
          isSaving={isSaving}
          episode={episode}
          serie={episode.Season.Serie}
        />
        <Content style={{ margin: "0 26px" }}>
          <div
            style={{
              padding: 24,
              margin: "16px 0",
              marginRight: "315px",
              marginTop: "100px",

              minHeight: 360,

              borderRadius: 5,
              background: "white",
            }}
          >
            <Slate
              editor={editor}
              initialValue={lines}
              onChange={(value) => {
                let context = "";

                console.log("[onChange] editor.selection : ", editor.selection);
                try {
                  const parent = Editor.parent(editor, editor.selection);
                  console.log("[onChange] Parent :", parent);
                  if (parent.length > 0) context = Node.string(parent[0]);
                } catch (e) {
                  console.log(e, editor.selection);
                }

                const isAstChange = editor.operations.some(
                  (op) => "set_selection" !== op.type
                );
                if (isAstChange) {
                  // Save the value to Local Storage.
                  // const content = JSON.stringify({ lines: value });
                  // localStorage.setItem("content", content);
                  setSelectedText({
                    selection: selectedText.selection,
                    context,
                  });
                  setDocContent({ lines: value });
                  console.log(
                    "[onChange] selectedText :",
                    selectedText.selection
                  );
                }
                if (
                  editor.operations.every((op) => op.type === "set_selection")
                ) {
                  console.log(
                    "[onChange] selectedText :",
                    Editor.string(editor, editor.selection)
                  );
                  setSelectedText({
                    selection: Editor.string(editor, editor.selection).slice(
                      0,
                      24
                    ),
                    context,
                  });
                }
              }}
            >
              <Editable
                style={{
                  outline: "transparent",
                }}
                id={"printablediv"}
                onDrop={onDrop}
                onBlur={saveSelection}
                onKeyDown={(event) => {
                  if (
                    event.key === ":" ||
                    event.key === "!" ||
                    event.key === "?"
                  ) {
                    event.preventDefault();
                    editor.insertText("\xA0" + event.key);
                  } else if (event.key === "Enter" && event.shiftKey) {
                    event.preventDefault();
                    editor.insertText("\n");
                  }
                }}
                renderElement={renderElement}
                renderLeaf={renderLeaf}
              />
            </Slate>
          </div>
          <PersoModal
            perso={speakerElement}
            onClose={() => setPersoIsOpen(false)}
            modalIsOpen={modalPersoIsOpen}
            onPersoChoose={setSpeaker}
          />
          <DicoModal
            markAsDico={markAsDico}
            dicoData={searchDico}
            onClose={() => setDicoIsOpen(false)}
            isOpen={modalDicoIsOpen}
          />
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Nabook ©2023 Created by Lulu with ❤️
        </Footer>
      </Layout>
    </Layout>
  );
};
export { fileLoader, MainPage };

/**
 * <Content
          // className="main"
          style={{
            backgroundColor: "#f4f5fb",
            minHeight: "100vh",
            paddingBottom: 100,

            display: "flex",
          }}
        >
         
      <div
      style={{
        margin: 10,
        padding: 20,

        borderRadius: 5,
        border: "1px solid rgba(0, 0, 0, 0.5)",
        backgroundColor: "#fff",
      }}
    >
      <Slate
        editor={editor}
        initialValue={gptToSlate(initialValue)}
        onChange={(value) => {
          const isAstChange = editor.operations.some(
            (op) => "set_selection" !== op.type
          );
          if (isAstChange) {
            // Save the value to Local Storage.
            const content = JSON.stringify(value);
            // localStorage.setItem("content", content);
            // TODO: save to DB
            console.log(content);
          }
        }}
      >
        <Editable renderElement={renderElement} renderLeaf={renderLeaf} />
      </Slate>
    </div>
    <PersoModal
      perso={speakerElement}
      onClose={() => setIsOpen(false)}
      modalIsOpen={modalIsOpen}
      onPersoChoose={(perso, changeAll) => {
        setIsOpen(false);
        CustomEditorConfig.setSpeaker(
          editor,
          perso,
          speakerElement,
          changeAll
        );
      }}
    />
  </Content>
 */

/* <input
        onChange={(e) => {
          CustomEditor.setSpeaker(editor, e.target.value);
        }}
      /> */
